// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".z38tO{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;padding:.25rem .75rem;border-radius:.25rem;background-color:#f7f8f8;cursor:pointer;color:#595757;font-size:14px;font-size:.875rem;font-weight:400;line-height:23px;line-height:1.4375rem;font-family:var(--base-font)}@media(max-width:767px){.z38tO{font-size:1rem;line-height:1.625rem}}.z38tO svg{margin-left:.25rem}", ""]);
// Exports
exports.locals = {
	"toggler": "z38tO"
};
module.exports = exports;
